<template>
  <el-dialog
    v-if="isShow"
    :title="typeof surcharge.id !== 'undefined' ? 'Edit Invoice Surcharge' : 'Create Invoice Surcharge'"
    :visible.sync="isShow"
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
  >
    <el-form
      ref="invoiceSurchargeForm"
      v-loading="isSaving"
      :rules="rules"
      :model="surcharge"
    >
      <el-row>
        <el-col :md="24">
          <el-form-item
            label="Rate Surcharge"
            prop="rate_surcharge"
          >
            <el-select
              v-model="surcharge.rate_surcharge"
              :loading="isLoadingRateSurcharges"
              value-key="id"
              placeholder="Select a rate surcharge"
              class="w-100"
              clearable
            >
              <el-option
                v-for="rateSurcharge in rateSurcharges"
                :key="rateSurcharge.id"
                :label="`${rateSurcharge.name || '-'}, ${rateSurcharge.short || '-'}`"
                :value="rateSurcharge"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isShow = false">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof surcharge.id !== 'undefined' ? updateSurcharge() : createSurcharge()"
      >
        {{ typeof surcharge.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      surcharge: {},
      rateSurcharges: [],
      isShow: false,
      isSaving: false,
      isFullscreen: false,
      isLoadingRateSurcharges: false,
      rules: {
        rate_surcharge: [
          { required: true, message: 'Rate Surcharge is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadLists()
  },
  methods: {
    loadLists () {
      this.isLoadingRateSurcharges = true
      this.$sdk.ratesurcharge.list(builder => {
        builder.filters = { rate_surcharge_fee_only: [true] }
        builder.page = 1
        builder.limit = 100
        builder.order = 'uuid:asc'
      }).then(res => {
        this.rateSurcharges = res
      })
        .finally(() => {
          this.isLoadingRateSurcharges = false
        })
    },
    createSurcharge () {
      this.$refs.invoiceSurchargeForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.$sdk.invoicesurcharge.create(this.surcharge, builder => {
            builder.context = { resource: 'account', id: this.accountId }
            builder.include = ['rate_surcharge']
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.isShow = false
              this.$emit('saved')
            })
        }
      })
    },
    updateSurcharge () {
      this.$refs.invoiceSurchargeForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.surcharge.update(builder => {
            builder.context = { resource: 'account', id: this.accountId }
            builder.include = ['rate_surcharge']
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.isShow = false
              this.$emit('saved')
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
